<template>
    <div>
        <el-row>
            <el-col :span="3">
                <div style="position: relative;height: 40px;line-height: 40px;">
                    <template>
                        <span>{{ $t('operation.task.analyseTime') }}:</span>
                        <el-tooltip :content="$t('operation.task.analyseTimeTip')" placement="top">
                            <i class="el-icon-question" style="position: absolute;top:0;right:6px;"></i>
                        </el-tooltip>
                    </template>
                </div>
            </el-col>
            <el-col :span="21">
                <el-row>
                    <el-col :span="12" style="height: 40px;line-height: 40px;" v-for="(item, index) in formData" :key="index">{{ item.timePeriods[0] }} - {{
                item.timePeriods[1] }};{{
                $t('operation.task.scale') }}:{{
                item.scale
            }}%;</el-col>
                </el-row>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import moment from 'moment'
export default {
    data() {
        return {
            popupModal: false,
            formData: [],
        }
    },
    methods: {
        open(data) {
            this.formData = data;
            this.popupModal = true;
        },
    }
}
</script>

<style scoped></style>